import React from 'react';
import CustomImage from '../../../components/custom-image';
import ContentSlider from '../../../components/content-slider';

const AgricultureAnimal = () => {
  const slider = {
    slides: [
      <div className="child-education-slider">
        <CustomImage
          className="custom-image"
          imageName="agriculture1.jpg"
          alt="Agriculture Animal"
          maxWidth="276"
        />
      </div>,
      <div className="child-education-slider">
        <CustomImage
          className="custom-image"
          imageName="agriculture2.jpg"
          alt="Agriculture Animal"
          maxWidth="276"
        />
      </div>,
      <div className="child-education-slider">
        <CustomImage
          className="custom-image"
          imageName="agriculture3.jpg"
          alt="Agriculture Animal"
          maxWidth="277"
        />
      </div>
    ],
  };
  return (
    <div className="accordion-body">
       <div className="sd-content">
          <div className="left">
            <div className="blue-box">
              <p className="feature-title"><strong>Key Features</strong></p>
              <div className="sd-column">
                <div className="left">
                  <p className="feature-subtitle">More than</p>
                  <p className="bold-text blue-text">12</p>
                  <p className="feature-benifit">initiatives across our Group companies</p>
                </div>
                <div className="right">
                  <p className="feature-subtitle">More than</p>
                  <p className="bold-text blue-text">90,000</p>
                  <p className="feature-benifit">farmers beneﬁted</p>
                </div>
              </div>
              
            </div>
            <div className="bottom-content">
              <p><strong>Types of Interventions</strong></p>
              <p>
                Climate-change adaptation; Wadi-based agriculture; Water-shed rejuvenation; Agriculture-based natural resource management; Dairy
                and livestock development; Farmer training; SHGs; Co-operatives; Veterinary care; Irrigation channel maintenance
              </p>
            </div>
          </div>
          <div className="right">
            <ContentSlider
              data={slider.slides}
              customClass="blue-dots-slider"
              slidesToShow={1}
              slidesToScroll={1}
              dots={true}
            />
          </div>
      </div>
    </div>
  );
};

export default AgricultureAnimal;
